<template>
  <div class="d-flex align-items-center justify-content-center h-100 w-25">
    <div :class="`${ !$helper.isPlayerDemo12 ? 'w-50' : 'w-100'} h-100`">
      <b-btn
        v-b-modal="'help'"
        :class="['h-100 text-primary btn-white', {'border-right': !$helper.isPlayerDemo12 }]"
        block
        @click="onHelpButtonClick"
      >
        <i class="ti ti-2x ti-fw ti-question-circle" />{{ $t('help.test_title') }}
      </b-btn>
    </div>
    <div v-if="!$helper.isPlayerDemo12" class="w-50 h-100">
      <div
        :style="`background-image: url(${$helper.getImage($test.image.upload_file_path)})`"
        class="h-100 test-image"
      />
    </div>
    <b-modal
      id="help"
      ref="helpModal"
      :title="$t('help.title')"
      size="lg"
    >
      <help-video />

      <!-- eslint-disable-next-line vue/no-v-html -->
      <div v-html="$t('help.recommandations')" />
      <div
        slot="modal-footer"
        class="w-100"
      >
        <b-btn
          class="float-right"
          variant="primary"
          @click="$refs.helpModal.hide()"
        >
          {{ $t('actions.close') }}
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import HelpVideo from '@/components/help-video';

  export default {
    name: 'HelpButtonComponent',
    components: {
      HelpVideo,
    },
    mounted(){
      this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
        this.$root.$children[0].setFullScreen();
      });
    },
    methods: {
      onHelpButtonClick() {
        this.$root.$children[0].setFullScreen();
        this.$bus.$emit('modal-video-help-open');
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';

  .test-image {
    background: {
      size: contain;
      position: center;
      repeat: no-repeat;
    }
  }
</style>
